
export const sentryRelease = 'gosu-party@PROJECT-TFE-20250217-01'; 

